export function isFunction(payload){return typeof payload==="function"}export default isFunction;